import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import SHSForm from '../utils/shs-form'
import InputElement from '../utils/input'
import { generatePasswordResetLink } from '../../actions/auth'
import { routes } from '../../constants/routes'

const PasswordHelp = ({ dispatch, fireauth }) => {
    const [linkSent, setLinkSent] = useState(false)

    const successFX = () => {
        setLinkSent(true)
    }

    const submitFX = (formData, formId) => {
        dispatch(generatePasswordResetLink(fireauth, formData.email, formId))
    }

    return (
        <div className="box m-auto w-50 mt-5">
            <h1>Password Help</h1>
            { linkSent
                ? <p>Check your email, we sent you a link to help reset your password.</p>
                : (
                    <>
                        <p>Enter the email address associated with your account and we will send you a link to reset your password.</p>
                        <SHSForm submitFX={submitFX} successFX={successFX} buttonLabel="Get Password Help" buttonClass="black center" buttonDisabled={!fireauth ? true : false}>
                            <InputElement
                                type="email"
                                default=""
                                id="email"
                                label="Email Address"
                                placeholder="user@example.com"
                                extraClass="flex-100"
                                required />
                        </SHSForm>
                    </>
                )
            }
            <p>
                <Link to={routes.authLogin}>Return to login</Link>
            </p>
        </div>
    )
}

export default connect()(PasswordHelp)
